import React, { Component } from 'react';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { Redirect, Route } from 'react-router-dom';

let toastConfig = {
	message: '',
	position: {
		my: 'right top',
		at: 'right top',
		offset: '0 55',
	},
};

export function showSuccessMessage(message) {
	//alert('diego');
	toastConfig.message = message;
	notify(toastConfig, 'success', 10000);
}
export function formatCPF(v) {
	v = v.replace(/\D/g, '');

	v = v.replace(/(\d{3})(\d)/, '$1.$2');

	v = v.replace(/(\d{3})(\d)/, '$1.$2');

	v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

	return v;
}
export function formatPhone(v) {
	v = v.replace(/\D/g, '');

	v = v.replace(/^(\d\d)(\d)/g, '($1) $2');

	v = v.replace(/(\d{4})(\d)/, '$1-$2');

	return v;
}

export function formatCep(v) {
	v = v.replace(/D/g, '');

	v = v.replace(/^(\d{5})(\d)/, '$1-$2');

	return v;
}
export function formatCNPJ(v) {
	v = v.replace(/\D/g, '');

	v = v.replace(/^(\d{2})(\d)/, '$1.$2');

	v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');

	v = v.replace(/\.(\d{3})(\d)/, '.$1/$2');

	v = v.replace(/(\d{4})(\d)/, '$1-$2');

	return v;
}
export function formatNumberDecimalPlaces(v, decimalplaces) {
	if (v) {
		v = v.toLocaleString('pt-BR', { decimalPlaces: decimalplaces });
	}
	return v;
}

export function showConfirmationMessage(message, fncYes = null, fncNo = null) {
	let result = confirm(message, 'Confirme a solicitação');
	result.then(dialogResult => {
		if (dialogResult) {
			if (fncYes !== null) fncYes();
		} else {
			if (fncNo) fncNo();
		}
	});
}
export function showErrorMessage(message) {
	//alert('diego');
	toastConfig.message = message;
	notify(toastConfig, 'error', 10000);
}
export function showInfoMessage(message) {
	//alert('diego');
	toastConfig.message = message;
	notify(toastConfig, 'info', 10000);
}
export function showWarnMessage(message) {
	toastConfig.message = message;
	notify(toastConfig, 'warning', 10000);
}
export function showMessage(config) {
	toastConfig.message = config.text;
	notify(toastConfig, config.type, 10000);
}
export function handleError(error, defaultMessage = '') {
	let baseMessage = 'Ocorreu um erro não identificado na requisição. Entre em contato com o suporte';
	//Quasar Toast Schema
	let configMessage = {
		text: 'Falha de conexão com a internet.',
		type: 'error',
	};
	//Setup Error Message
	if (typeof error !== 'undefined') {
		if (error.hasOwnProperty('message')) {
			configMessage.text = error.message;
		}
	}

	if (typeof error.response !== 'undefined') {
		//Setup Generic Response Messages
		if (error.response.status === 403) {
			configMessage.text = 'Seu usuário não tem permissão ou não não está autenticado. Faça o login novamente.';
		} else if (error.response.status === 404) {
			configMessage.text = 'Operação não encontrada. Entre em contato com o suporte.';
		} else if (error.response.status === 405) {
			configMessage.text = 'Seu usuário não tem permissão de realizar essa operação.';
		} else if (error.response.status === 422) {
			//Validation Message
		} else if (error.response.status === 401) {
			configMessage.text = 'Usuário não autenticado. É necessário realizar o login na aplicação.';
			if (error.hasOwnProperty('response') && error.response.hasOwnProperty('data')) {
				if (error.response.data.hasOwnProperty('message') && error.response.data.message.length > 0) {
					configMessage.type = 'error';
					configMessage.text = error.response.data.message;
				}
			}
		} else if (error.response.status >= 500) {
			if (configMessage.text.length === 0) {
				configMessage.text = baseMessage;
			} else {
				configMessage.text = defaultMessage;
			}
		} else if (error.response.status === 400) {
			configMessage.text =
				'Um ou mais campos não foram preenchidos corretamente. Verifique e execute novamente a operação:\r\n\r\n';
			configMessage.type = 'warning';
			if (error.response.data) {
				for (var k in error.response.data) {
					for (var x in error.response.data[k]) {
						configMessage.text += error.response.data[k][x] + '\r\n';
					}
				}
			}
		} else {
			//Try to Use the Response Message
			if (error.hasOwnProperty('response') && error.response.hasOwnProperty('data')) {
				if (error.response.data.hasOwnProperty('message') && error.response.data.message.length > 0) {
					configMessage.text = error.response.data.message;
				}
			}
		}
	}
	// console.log(configMessage.type);
	//Toast the Message
	if (configMessage.text.length > 0) {
		showMessage(configMessage);
	} else {
		configMessage.text = baseMessage;
		showMessage(configMessage);
	}
}
